import React from 'react';
import { useLocation } from '@reach/router';

import DirectFeedbackUpload, { RequirementType } from './index';
import routes from '../../messages/routes';
import { steps, translateRoute } from '../../utils/routes';
import { PageType } from '../Passengers/PassengerContainer';

export interface PassengerDocumentUploadProps {
  pageType: PageType;
  claimNumber: string;
  documentTypeRouteParam: string;
  passengerId: string;
  withNavigation: boolean;
}

const translatedRouteToTypeMap: { [key: string]: RequirementType } = [
  [RequirementType.Identification, routes[steps.UploadId]],
  [
    RequirementType.BookingConfirmation,
    routes[steps.UploadBookingConfirmation],
  ],
  [RequirementType.BookingDocs, routes[steps.UploadBoardingPass]],
  [RequirementType.PaymentReceipt, routes[steps.UploadPaymentReceipt]],
  [RequirementType.DelayConfirmation, routes[steps.UploadDelayConfirmation]],
  [RequirementType.BirthCertification, routes[steps.UploadBirthCertificate]],
].reduce(
  (translatedUrls, [requirementType, route]) => ({
    ...translatedUrls,
    [translateRoute(route)]: requirementType,
  }),
  {}
);

const translatedRouteToCategoryId: { [key: string]: RequirementType } = [
  ['2', routes[steps.UploadId]],
  ['3', routes[steps.UploadBookingConfirmation]],
  ['5', routes[steps.UploadBoardingPass]],
].reduce(
  (translatedUrls, [requirementType, route]) => ({
    ...translatedUrls,
    [translateRoute(route)]: requirementType,
  }),
  {}
);

/**
 * This component is used to determine what document page should be displayed
 * depending on documentTypeParam from URL
 */
const PassengerDocumentUpload = (props: PassengerDocumentUploadProps) => {
  const { state } = useLocation();

  return (
    <DirectFeedbackUpload
      {...props}
      categoryId={
        state?.categoryId ||
        translatedRouteToCategoryId[props.documentTypeRouteParam]
      }
      documentType={
        props.documentTypeRouteParam
          ? translatedRouteToTypeMap[props.documentTypeRouteParam]
          : undefined
      }
    />
  );
};

export default PassengerDocumentUpload;
